import { render, staticRenderFns } from "./receiver.vue?vue&type=template&id=00c66b20&scoped=true&"
import script from "./receiver.vue?vue&type=script&lang=js&"
export * from "./receiver.vue?vue&type=script&lang=js&"
import style0 from "./receiver.vue?vue&type=style&index=0&id=00c66b20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c66b20",
  null
  
)

export default component.exports